import axiosService from '../axios'

export const list = (params?: any) => {
  return axiosService({
    url: '/api.sell-contract',
    method: 'get',
    params,
  })
}

export const listByCustomer = (params?: any) => {
  return axiosService({
    url: '/api.sell-contract/customer',
    method: 'get',
    params,
  })
}

export const listAll = (params?: any) => {
  return axiosService({
    url: '/api.sell-contract/all',
    method: 'get',
    params,
  })
}

export const count = () => {
  return axiosService({
    url: `/api.sell-contract/count-pending`,
    method: 'get',
  })
}

export const get = (id: number) => {
  return axiosService({
    url: `/api.sell-contract/${id}`,
    method: 'get',
  })
}

export const update = (id: number, data: any) => {
  return axiosService({
    url: `/api.sell-contract/${id}`,
    method: 'put',
    data,
  })
}

export const apply = (id: number) => {
  return axiosService({
    url: `/api.sell-contract/${id}/apply`,
    method: 'put',
  })
}

export const reject = (id: number, data: any) => {
  return axiosService({
    url: `/api.sell-contract/${id}/reject`,
    method: 'put',
    data,
  })
}

export const remake = (id: number, data: any) => {
  return axiosService({
    url: `/api.sell-contract/${id}/remake`,
    method: 'put',
    data,
  })
}

export const approve = (id: number) => {
  return axiosService({
    url: `/api.sell-contract/${id}/approve`,
    method: 'put',
    data: {},
  })
}

export const destroy = (id: number) => {
  return axiosService({
    url: `/api.sell-contract/${id}`,
    method: 'delete',
  })
}

export const create = (data: any) => {
  return axiosService({
    url: '/api.sell-contract',
    method: 'post',
    data,
  })
}
